module.exports = __webpack_public_path__ + "img/main-logo.f1b78c02.jpg";